const pickOne = (elements) => {
  const sumWeights = elements.reduce((sum, element) => element.weight + sum, 0);
  let rand = Math.random() * sumWeights;

  return elements.find((element) => {
    rand -= element.weight;
    return rand <= 0;
  });
};

const pickMultiple = (elements, num = 6) => {
  if (num <= 0 || elements.length <= 0) return [];

  const picked = pickOne(elements);
  const remaining = elements.filter(({ id }) => id !== picked.id);

  return [picked, ...pickMultiple(remaining, num - 1)];
};

export { pickOne, pickMultiple };
